import { useState, useEffect } from 'react';
import Styles from './OurCustomers.module.scss';
import { useAPI } from 'components/lib';

export const OurCustomers = ({ ...props }) => {

    const customerIcons = useAPI('/api/landing/customers');

    const ResizableImage = ({ src, alt }) => {
        const [scaleFactor, setScaleFactor] = useState(1);

        useEffect(() => {
            const img = new Image();
            img.onload = () => {
                const ratio = img.height / img.width;
                const factor = (img.height < 100 || ratio < 0.6) ? 2.2 : 1;
                setScaleFactor(factor);
            };
            img.src = `${process.env.REACT_APP_GLOBAL_MEDIA_URL}${src}`;
        }, [src]);

        const style = {
            maxWidth: '3em',
            maxHeight: '3em',
            width: 'auto',
            height: 'auto',
            transform: `scale(${scaleFactor})`
        };

        return <img src={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}${src}`} alt={alt} style={style} />;
    };

    return (
        <div id='customerContainer' className={Styles.customerContainer}>
            <p className={Styles.blueText}>
                Our Trusted Customers
            </p>
            <div id='logosContainer' className={Styles.logosContainer}>
                {
                    customerIcons?.data?.map((company, index) => (
                        <ResizableImage
                            key={`${index}${company.name}`}
                            src={company.logo}
                            alt={`${company.name} Logo`}
                        />
                    ))
                }

            </div>
        </div>
    )
}